module.exports = __webpack_public_path__ + "media/images/diy/extras_bg-bb419ce42233d09614c0914d99bf3792.png";